import { c as _c } from "react/compiler-runtime";
import { getPriorityFromIssue } from "@/lib/issue/config";
import { Badge } from "../ui/badge";
export const PriorityBadge = t0 => {
  const $ = _c(5);
  const {
    issue
  } = t0;
  let t1;
  if ($[0] !== issue) {
    t1 = getPriorityFromIssue(issue);
    $[0] = issue;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const priority = t1;
  const variant = issue.completedAt ? "default" : priority?.badgeVariant ?? "default";
  const t2 = priority?.label;
  let t3;
  if ($[2] !== t2 || $[3] !== variant) {
    t3 = <Badge variant={variant}>{t2}</Badge>;
    $[2] = t2;
    $[3] = variant;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};